<!--
 * @Author: maggot-code
 * @Date: 2021-04-22 09:43:08
 * @LastEditors: maggot-code
 * @LastEditTime: 2021-04-23 15:38:29
 * @Description: file content
-->
<template>
    <div class="k-count">k-count</div>
</template>

<script lang='ts'>
import { defineComponent } from 'vue'
export default defineComponent({
    name: 'k-count',
    setup() {},
})
</script>